module.exports = __webpack_public_path__ + "img/object-mark1.f5af62a2.png";